import { createFileRoute } from "@tanstack/react-router";

import { JoinScreen } from "@/modules/coaching/join/screens/JoinScreen";
import { JoinUnavailable } from "@/modules/coaching/join/screens/JoinUnavailable";
import { joinScreenLoader } from "@/modules/coaching/join/utils/joinScreenLoader";

export const Route = createFileRoute("/$sessionCode/")({
  loader: joinScreenLoader,
  component: JoinScreen,
  errorComponent: JoinUnavailable,
});
